// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChartInstrumentWatermarkRendererBase } from './TerceraChartInstrumentWatermarkRendererBase';
export class TerceraChartWatermarkRenderer extends TerceraChartInstrumentWatermarkRendererBase {
    constructor(chart) {
        super(chart);
        if (chart) {
            if (chart.model)
                chart.model.ModelItemChanged.Subscribe(this.UpdateCache, this);
        }
    }
    GetInstrument() {
        return this.chart.Instrument();
    }
    Dispose() {
        const chart = this.chart;
        if (chart) {
            if (chart.model) {
                chart.model.ModelItemChanged.UnSubscribe(this.UpdateCache, this);
            }
        }
        super.Dispose();
    }
}
